import { Component, OnInit , Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  public workshops:Array<{id: number, title: string, tema: string, horario: string}> = [
      {id: 1, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 2, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 3, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 4, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 5, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 6, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
      {id: 7, title: 'Taller internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'}
  ];

  public conferences:Array<{id: number, title: string, tema: string, horario: string}> = [
    {id: 1, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 2, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 3, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 4, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 5, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 6, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'},
    {id: 7, title: 'Conferencia internacional de sistemas', tema:'Motivación y autoestima', horario: '10 am'}
];

  constructor(public routs : Router, public route: ActivatedRoute,
              public dialog: MatDialog) { }

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id');
    console.log(id)
  }
  public ruta(){
    this.routs.navigate(['/career']);
  }
  public datos(){
    this.routs.navigate(['/mis-datos']);
  }
  public escanner(){
    this.routs.navigate(['/escanner']);
  }
  public cerrarSesion(){
    this.routs.navigate(['/login']);
  }
  openDialog(){
    const dialogRef = this.dialog.open(AcercaComponent);
  }
}

@Component({
  selector: 'acerca-component',
  templateUrl: 'acerca.component.html',
  styleUrls: ['./acerca.component.scss']
})
export class AcercaComponent {

  constructor(
    public dialogRef: MatDialogRef<AcercaComponent>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}